<template>
  <div>
    <div class="d-flex flex-wrap align-center justify-space-between" style="gap: 12px;">
      <h2 class="mb-0">Relatório de Ordem de Serviço</h2>
      <v-btn outlined color="primary" @click="$router.push('/relatorios#comercial')">
        <v-icon left>mdi-arrow-left</v-icon>
        Voltar ao menu
      </v-btn>
    </div>

    <div class="d-flex flex-wrap align-center mt-4 mb-4" style="gap: 12px;">
      <v-text-field v-model="filtros.dataInicio" type="date" label="Solicitação inicial" solo hide-details clearable class="c-filtro" />
      <v-text-field v-model="filtros.dataFim" type="date" label="Solicitação final" solo hide-details clearable class="c-filtro" />
      <v-autocomplete
        v-model="filtros.codigo"
        :items="opcoesCodigos"
        label="Código"
        solo
        hide-details
        clearable
        class="c-filtro"
      />
      <v-autocomplete
        v-model="filtros.job"
        :items="opcoesJobs"
        label="JOB"
        solo
        hide-details
        clearable
        class="c-filtro"
      />

      <v-btn color="primary" :loading="loading" @click="buscarDados">
        <v-icon left>mdi-refresh</v-icon>
        Recarregar
      </v-btn>

      <v-menu>
        <template v-slot:activator="{ on }">
          <v-btn color="primary" outlined v-on="on" :disabled="loading || dadosFiltrados.length === 0">
            <v-icon left>mdi-file-export-outline</v-icon>
            Exportar
          </v-btn>
        </template>
        <v-list>
          <v-list-item link @click="exportarXlsx"><v-list-item-title>Excel</v-list-item-title></v-list-item>
          <v-list-item link @click="exportarPdfTabela"><v-list-item-title>PDF</v-list-item-title></v-list-item>
        </v-list>
      </v-menu>
    </div>

    <div ref="areaPdf">
      <v-data-table :headers="headers" :items="dadosFiltrados" :loading="loading" item-key="_id" rows-per-page-text="Linhas por página:" page-text="{0}-{1} de {2}" class="elevation-1">
        <template v-slot:item.dataSolicitacao="{ item }">{{ formatarDataPtBr(item.dataSolicitacao) }}</template>
        <template v-slot:item.prazo="{ item }">{{ formatarDataPtBr(item.prazo) }}</template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import relatorioOSService from "@/views/Relatorios/services/relatorioOSService";
import { exportarExcel, exportarPdfTabela as exportarPdfTabular, formatarDataPtBr, normalizarTexto } from "@/views/Relatorios/base/relatorioBaseUtils";

import relatorioPermissionMixin from "@/mixins/relatorioPermissionMixin";

export default {
  name: "RelatorioComercialOSView",
  mixins: [relatorioPermissionMixin],
  data() {
    return {
      relatorioSchemas: ["Project"],
      relatorioFiltrarPorOwner: true,
      loading: false,
      dados: [],
      filtros: {
        dataInicio: "",
        dataFim: "",
        codigo: "",
        job: ""
      },
      headers: [
        { text: "CÓD.", value: "codigo" },
        { text: "Número Proposta", value: "orcamento" },
        { text: "JOB", value: "job" },
        { text: "Cliente", value: "cliente" },
        { text: "Contato", value: "contato" },
        { text: "Fone", value: "fone" },
        { text: "Dt.Solicitação", value: "dataSolicitacao" },
        { text: "Prazo", value: "prazo" },
        { text: "Vendedor", value: "vendedor" }
      ]
    };
  },
  computed: {
    opcoesCodigos() {
      return [...new Set(this.dados.map((item) => normalizarTexto(item.codigo)).filter(Boolean))]
        .sort((a, b) => a.localeCompare(b));
    },
    opcoesJobs() {
      return [...new Set(this.dados.map((item) => normalizarTexto(item.job)).filter(Boolean))]
        .sort((a, b) => a.localeCompare(b));
    },
    dadosFiltrados() {
      const codigo = normalizarTexto(this.filtros.codigo).toLowerCase();
      const job = normalizarTexto(this.filtros.job).toLowerCase();

      return this.dados.filter((item) => {
        const codigoOk = !codigo || normalizarTexto(item.codigo).toLowerCase().includes(codigo);
        const jobOk = !job || normalizarTexto(item.job).toLowerCase().includes(job);
        return codigoOk && jobOk;
      });
    }
  },
  watch: {
    "filtros.dataInicio"() { this.buscarDados(); },
    "filtros.dataFim"() { this.buscarDados(); }
  },
  methods: {
    formatarDataPtBr,
    async buscarDados() {
      this.loading = true;
      try {
        const lista = await relatorioOSService.listarRelatorioOS(this.filtros);
        this.dados = Array.isArray(lista) ? lista : [];
      } finally {
        this.loading = false;
      }
    },
    exportarXlsx() {
      const linhas = this.dadosFiltrados.map((item) => ({
        "CÓD.": item.codigo,
        "Número Proposta": item.orcamento,
        JOB: item.job,
        Cliente: item.cliente,
        Contato: item.contato,
        Fone: item.fone,
        "Dt.Solicitação": this.formatarDataPtBr(item.dataSolicitacao),
        Prazo: this.formatarDataPtBr(item.prazo),
        Vendedor: item.vendedor
      }));

      exportarExcel(linhas, "relatorio-os.xlsx");
    },
    async exportarPdfTabela() {
      await exportarPdfTabular({
        headers: this.headers,
        rows: this.dadosFiltrados,
        nomeArquivo: "relatorio-os.pdf",
        tituloRelatorio: "Relatório de Ordem de Serviço",
        formatadoresPorCampo: {
          dataSolicitacao: (valor) => this.formatarDataPtBr(valor),
          prazo: (valor) => this.formatarDataPtBr(valor)
        }
      });
    }
  },
  async mounted() {
    if (this.relatorioTemPermissao(this.relatorioSchemas)) {
      await this.buscarDados();
    }
  }
};
</script>

<style scoped>
.c-filtro {
  max-width: 220px;
}
</style>
